const env = {
  apiUrl: process.env.REACT_APP_API_URL || ''
};

type EnvironmentVariablesType = typeof env;

const environmentVariables: EnvironmentVariablesType = env;

export default environmentVariables;
